import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './2018.css';

class Complete_agreement extends Component {
  componentDidMount() {
    document.title = '龍邑遊戲|會員服務條款';
  }
  render() {
    return (
      <div>
        <div className='nav' style={{ position: 'fixed;top:0' }}>
          <div className='nav_container'>
            <a href='https://game.longeplay.com.tw'>
              <div className='nav_logo' />
            </a>
          </div>
        </div>
        <div className='content-terms'>
          <div>
            <h1>龍邑會員服務同意書</h1>
            <div>
              <div>
                <div className='info'>
                  歡迎您加入龍邑股份有限公司（以下簡稱「龍邑」）並使用龍邑所提供之各項會員服務，為保障您的權益，在您加入龍邑會員及使用龍邑會員服務之前，請詳細閱讀本件「龍邑會員服務同意書」（下稱「本同意書」所有內容，本同意書共包含【龍邑會員服務條款】(下稱「本條款」) 、【隱私權政策】、【個人資料提供同意書】等三份文件，您同意當您在線上點選「同意」鍵時，代表您已經詳細閱讀、了解並願意遵守本同意書所有文件之約定內容。
                  <br />
                  <br />
                  <font color="red">提醒您：如果您是未成年人（未滿十八歲），或為限制行為能力人者或受輔助宣告之人，您必須告知法定代理人（如：父母、監護人、輔助人）使其詳閱、瞭解本服務同意書內容，並取得法定代理人（如：父母、監護人、輔助人）之允許始得進行。當您使用或繼續使用龍邑會員得使用之服務時，代表您對本同意書之同意及其他意思表示，均已取得法定代理人（如：父母、監護人、輔助人）之允許。</font>
                  <br />
                  <br />
                  提醒您：您要先行審閱本同意書三日以上，再按「同意」。
                  <br />
                  <br />
                  <h2 id='service'>
                    <u>龍邑會員服務條款</u>
                  </h2>
                  <p>
                    一、當事人及其基本資料
                    <br />
                    (一)	消費者（以下簡稱「消費者」或「會員」，請依會員註冊流程填寫基本資料）
                    <br />
                    (二)	企業經營者名稱：龍邑股份有限公司（以下簡稱「龍邑」或「本公司」）
                    <br />
                    代表人：尤佑文
                    <br />
                    統一編號：54700022
                    <br />
                    電話：(02)2218-8185
                    <br />
                    地址：新北市新店區建國路276號2樓
                    <br />
                    網址：https://game.longeplay.com.tw/game/support
                    <br />
                    電子郵件：longesupport@longeplay.com.tw
                    <br />
                    <br />
                    二、法定代理人
                    <br />
                    若消費者為限制行為能力人者或受輔助宣告之人，本同意書訂定時，應經消費者之法定代理人、監護人或輔助人閱讀、了解並同意本同意書之所有內容，本同意書始生效力；若您為無行為能力人者，本同意書之訂定，則應由您的法定代理人或監護人代為意思表示。 
                    <br />
                    若有限制行為能力人未經同意或無行為能力人或受輔助宣告之人未由法定代理人、監護人或輔助人代為付費購買點數致生法定代理人、監護人或輔助人主張退費時，法定代理人、監護人或輔助人得依<a href='#refund'>官網公告流程</a>，備妥證明文件並提出申請，經本公司確認及扣除贈送之點數、商品或其他服務(例如：虛擬貨幣或寶物、進階道具等)後，將依本條款第二十條進行計算並退還您剩餘未使用點數之費用金額。 
                    <br />
                    本公司應於官網首頁、遊戲登入頁面或購買頁面以中文明顯標示，若消費者為限制行為能力人或無行為能力人或受輔助宣告之人，除應符合第一項規定外，並應於消費者之法定代理人、監護人或輔助人閱讀、瞭解並同意本同意書之所有內容後，方得使用本服務(定義詳第三條)，本同意書各文件內容變更時亦同。
                    <br />
                    <br />
                    三、遵守會員規範及法律規定
                    <br />
                    消費者於註冊成為龍邑會員後，即取得會員資格並可使用本公司所提供之各項服務，包括但不限於使用線上遊戲、異業合作、金流儲值服務等(以下簡稱「本服務」)。 
                    <br />
                    消費者使用本服務時，除了同意遵守本同意書外，亦接受本公司其他針對會員之相關規範（包括但不限於營業規章、遊戲管理規則、客服中心內容、公告及注意事項等）及相關法令之規定。 
                    <br />
                    <br />
                    四、本服務簡介
                    <br />
                    使用本服務之消費者必須自行配備上網所需之各項電腦、手機設備，並負擔包括但不限於「網際網路連線費用」、「電話費用」等之電信相關費用。 
                    <br />
                    本服務之各項服務內容的所有權均屬龍邑所有，消費者僅得依本同意書之約定使用，不得出租、出借、移轉、私下交易買賣或讓與予其他第三人使用。 
                    <br />
                    為增進會員權益、擴充服務內容，龍邑將致力於提供會員各項新穎之服務或功能，消費者同意本同意書適用於現有或將來龍邑所提供消費者所得使用之各項服務。 
                    <br />
                    金流付費服務：為保障交易安全，消費者使用合法、正當之方式進行相關服務儲值，若消費者以冒名、詐騙、隱匿其真實年齡或其他虛偽不正之方式進行「儲值」或使他人代為進行「儲值」或其他遊戲內商品，龍邑除應依照各遊戲管理規則處理外，並得逕自終止本同意書及消費者之會員資格，及依法追究消費者因此衍生之民事及刑事責任。 
                    <br />
                    消費者得於開始使用遊戲後七日內，以書面通知龍邑解除本同意書，消費者無需說明理由及負擔任何費用，並得對未使用之付費購買點數提出退費申請；本公司經確認及扣除贈送點數、商品或其他服務(例如：虛擬貨幣或寶物、進階道具等)後，應退還消費者未使用點數之費用金額。 
                    <br />
                    <br />
                    五、真實登錄義務 
                    <br />
                    消費者使用龍邑所提供之各項服務，應於註冊時依註冊申請程序所提示之項目，登錄其本人正確、真實及完整之個人資料；當消費者的個人資料有異動時，其應立即通知本公司更新，以維持消費者個人資料之正確、真實及完整。 
                    <br />
                    本公司若有為提供本服務與消費者聯絡之必要，而消費者未登錄正確之個人資料或原提供之資料不符合真實且未更新，本公司得於消費者提供真實資料或更新資料前，暫停提供消費者本服務。但消費者得證明其為本同意書之當事人者，不在此限。 
                    <br />
                    為確保消費者使用本服務之權益，若本公司有驗證消費者個人資料之需要時，消費者須提供其身分證明、交易證明等資料供本公司查驗，若本公司查驗後認定消費者有冒用他人名義、詐騙或其他虛偽不正行等方式付費購買點數或遊戲內商品，，本公司得逕自終止本同意書及消費者之會員資格，並依法追究消費者因此衍生之法律責任。 
                    <br />
                    消費者於使用其電子郵件帳號、社群軟體帳號或手機會員帳號(例如：Apple ID)綁定本服務時，亦應確保各該綁定本服務之各類帳號中的個人資料，應屬正確、真實及完整，不得有冒用他人名義、詐騙或其他虛偽不正等方式付費購買點數或遊戲內商品，。若有違反，本公司得依前項約定辦理。 
                    <br />
                    <br />
                    六、本同意書之增訂及修改 
                    <br />
                    本公司修改本同意書各文件內容時，應於官網首頁、遊戲登入頁面或購買頁面公告之，並依消費者提供之通訊資料通知。 
                    <br />
                    本公司未依前項約定進行公告及通知者，本同意書各文件內容之變更無效。 
                    <br />
                    消費者於於第一項通知到達後十五日內： 
                    <br />
                    (一)	若未為反對之表示者，本公司依本同意書各文件變更後之內容繼續提供本服務。 
                    <br />
                    (二)	若以書面或電子郵件為反對之表示者，本公司依本條款第二十條約定處理。 
                    <br />
                    <br />
                    七、計費標準、變更及其通知相關規定 
                    <br />
                    本服務之遊戲收費計算包含下列方式： 
                    <br />
                    (一)	免費制。 
                    <br />
                    (二)	付費授權制。 
                    <br />
                    本服務之遊戲內（例如：遊戲商城、線上商店等）有提供需消費者額外付費購買之點數、商品或其他服務（例如：虛擬貨幣或寶物、進階道具等），本公司應在官網首頁、遊戲登入頁面或購買頁面公告載明付款方式及商品資訊。 
                    <br />
                    本公司應在官網首頁、遊戲登入頁面或購買頁面及遊戲套件包裝上載明下列事項：
                    <br />
                    (一)	依遊戲軟體分級管理辦法規定標示遊戲分級級別及禁止或適合使用之年齡層。
                    <br />
                    (二)	進行本遊戲服務之最低軟硬體需求。
                    <br />
                    (三)	有提供安全裝置者，其免費或付費資訊。
                    <br />
                    (四)	有提供直接或間接、部分或全部付費購買之機會中獎商品或活動，其活動內容、獎項、中獎機率百分比及中獎等資訊，並應記載「此為機會中獎商品，消費者購買或參與活動不代表即可獲得特定商品」等提示。
                    <br />
                    前項第四款所稱機率，指消費者付費後取得機會中獎商品或完成活動設定條件之機率。
                    <br />
                    本服務之遊戲費率調整時，本公司應自調整生效日30日前於官網首頁、遊戲登入頁面或購買頁面公告，並依消費者登錄之通訊資料通知消費者。 
                    <br />
                    本服務之遊戲費率如有調整時，應自調整生效日起按新費率計收；若新費率高於舊費率時，消費者在新費率生效日前已於遊戲中登錄之付費購買點數或遊戲費用應依舊費率計收。 
                    <br />
                    <br />
                    八、消費者帳號與密碼之使用 
                    <br />
                    消費者完成註冊程序後取得之帳號及密碼，僅供消費者使用，消費者應妥善保管該帳號及密碼，且不得將帳號及密碼出售、轉讓或出借予第三人使用。 
                    <br />
                    前項之密碼得依本公司系統之修改機制進行變更，本公司（含客服人員、遊戲管理員）不得主動詢問消費者之密碼，並應於契約終止後六十日內，保留消費者之帳號及附隨於該帳號之電磁紀錄。 
                    <br />
                    本同意書非因可歸責消費者之事由而終止者，消費者於前項期間內辦理續用後，有權繼續使用帳號及附隨於該帳號之電磁紀錄。 
                    <br />
                    本條第二項之期間屆滿時，消費者仍未辦理續用，本公司得刪除該帳號及附隨於該帳號之所有資料，但法令另有規定者不在此限。 
                    <br />
                    當事人一方如發現帳號、密碼被非法使用時，應立即通知對方並由本公司進行查證，經本公司確認有前述情事後，得暫停該組帳號或密碼之使用權，更換帳號或密碼予消費者，立即限制第三人就本服務之使用權利，並將相關處理方式揭載於遊戲管理規則。 
                    <br />
                    本公司應於暫時限制本服務遊戲使用權利之時起，即刻以官網公告、簡訊、電子郵件、推播或其他雙方約定之方式通知前項第三人提出說明。如該第三人未於接獲通知時起七日內提出說明，本公司應直接回復遭不當移轉之電磁紀錄予消費者，如不能回復時可採其他雙方同意之相當補償方式，並於回復後解除對第三人之限制。但本公司有提供免費安全裝置（例如：防盜卡、電話鎖等）而消費者不使用或有其他可歸責於消費者之事由，本公司不負回復或補償責任。 
                    <br />
                    前項之第三人不同意本公司前項之處理時，消費者得依報案程序，循司法途徑處理。 
                    <br />
                    本公司依本條第五項規定限制消費者或第三人之使用權時，在限制使用期間內，本公司不得向消費者或第三人收取費用。 
                    <br />
                    消費者如有申告不實之情形致生本公司或第三人權利受損時，應負一切法律責任。 
                    <br />
                    <br />
                    九、本服務之暫停或中斷 
                    <br />
                    本公司為維護本服務相關系統及軟硬體設備而預先規劃暫停本服務之全部或一部時，應於七日前於官網首頁、遊戲登入頁面或購買頁面公告。但因臨時性、急迫性或不可歸責於本公司之事由者，不在此限。 
                    <br />
                    因可歸責本公司事由，致消費者不能連線使用本服務時，應立即更正或修復。對於消費者於無法使用期間遭扣除遊戲費用或遊戲內商品，本公司應返還遊戲費用或商品，無法返還時則應提供其他合理之補償。 
                    <br />
                    消費者應於平時對電腦、手機設備採取適當之安全防護措施，以避免本服務之暫停、中斷可能造成其使用上之不便、資料遺失或其他經濟及時間上之損失。 
                    <br />
                    <br />
                    十、遊戲管理規則及違反遊戲管理規則之處理 
                    <br />
                    為規範遊戲進行之方式，本公司應訂立合理公平之遊戲管理規則，消費者應遵守本公司公告之遊戲管理規則。 
                    <br />
                    遊戲管理規則之變更應依本同意書第六條之程序為之。 
                    <br />
                    遊戲管理規則有下列情形之一者，其規定無效： 
                    <br />
                    (一)	牴觸本同意書之規定。  
                    <br />
                    (二)	剝奪或限制消費者於本同意書之權利。但本公司依照本同意書之規定處理者，不在此限。 
                    <br />
                    除本同意書另有規定外，有事實足證消費者於本服務之遊戲中違反遊戲管理規則時，本公司應於官網首頁、遊戲登入頁面或購買頁面公告，並依消費者登錄之通訊資料通知消費者。 
                    <br />
                    消費者第一次違反遊戲管理規則，本公司應通知消費者於一定期間內改善。經本公司通知改善而未改善者，本公司得依遊戲管理規則，按其情節輕重限制消費者之遊戲使用權利。如消費者因同一事由再次違反遊戲管理規則時，本公司得立即依遊戲管理規則限制消費者進行遊戲之權利。 
                    <br />
                    本公司依遊戲管理規則限制消費者進行遊戲之權利，每次不得超過七日。 
                    <br />
                    <br />
                    十一、遊戲歷程之保存與查詢 
                    <br />
                    本公司應保存消費者之個人遊戲歷程紀錄，且保存期間為六十日，以供消費者查詢。 
                    <br />
                    消費者得以書面、網路，或親至本公司之服務中心申請調閱消費者之個人遊戲歷程，且須提出與身分證明文件相符之個人資料以供查驗。 
                    <br />
                    前項之查詢費用為每次新台幣二百元，本公司接獲消費者之查詢申請，應提供第一項所列之消費者個人遊戲歷程，並於七日內以儲存媒介或書面、電子郵件方式提供資料。 
                    <br />
                    <br />
                    十二、企業經營者及消費者責任 
                    <br />
                    本公司應依本同意書之規定，負有於提供本服務時，維護其自身電腦系統，符合當時科技或專業水準可合理期待之安全性，惟不擔保各項服務之穩定、安全、不斷線及不出錯。 
                    <br />
                    本服務之電腦系統或電磁紀錄受到破壞，或電腦系統運作異常時，本公司應於採取合理之措施後儘速予以回復，惟不擔保各項服務之穩定、安全、不斷線及不出錯。 
                    <br />
                    本公司違反前二項規定或因遊戲程式漏洞致生消費者損害時，應依消費者受損害情形，負損害賠償責任。但本公司能證明其無過失者，得減輕其賠償責任。 
                    <br />
                    本公司電腦系統發生第二項所稱情況時，於完成修復並正常運作之前，本公司不得向消費者收取費用。 
                    <br />
                    消費者對於本服務中所傳送之電子郵件、檔案及其他資料，應進行備份或相關處理。對於消費者因傳送過程而造成電子郵件、檔案及其他相關電磁記錄資料之遺失，本公司不負任何擔保責任。 
                    <br />
                    本公司提供之本服務可能因其他協力廠商或相關電信業者網路系統軟硬體設備之故障或失靈；或人為操作上之疏失而造成中斷、暫時無法使用、遲延、資料傳輸或儲存上之錯誤；或遭第三人侵入系統篡改或偽造變造資料等。本公司就不可歸責於己之事由，不保證各項服務之穩定、安全、不斷線及不出錯，消費者並不得據此要求任何補償或賠償。 
                    <br />
                    本公司對於消費者因共用帳號、將其帳號及密碼出售、轉讓或出借予第三人使用或委託他人付費購買點數，得不予協助處理。 
                    <br />
                    <br />
                    十三、個人資料 
                    <br />
                    個人資料關於個人資料之保護，依相關法律規定處理。 
                    <br />
                    <br />
                    十四、電磁紀錄 
                    <br />
                    本服務之所有電磁紀錄均屬本公司所有，本公司並應依本同意書約定維持消費者相關電磁紀錄之完整。 
                    <br />
                    消費者對於前項電磁紀錄有使用支配之權利。但不包括本服務範圍外之移轉、收益行為。 
                    <br />
                    <br />
                    十五、資訊公開 
                    <br />
                    本公司應於遊戲網站上提供本服務遊戲之伺服器連線狀況等相關資訊，並定期更新。 
                    <br />
                    <br />
                    十六、隱私權政策 
                    <br />
                    消費者於會員註冊及其他特定資料，應依本同意書「隱私權政策」受到保護與規範。消費者同意於開始使用本服務時，即表示同意本公司得依據相關「隱私權政策」對消費者之個人資料進行蒐集與利用，包括但不限於跨國間的傳輸與儲存及其關係企業內部之利用。 
                    <br />
                    <br />
                    十七、會員內容之保留 
                    <br />
                    本公司不對於消費者所傳送、張貼或發表之內容（包括但不限於文字、圖片、音樂、影像、軟體、資訊及各種資料等）進行任何形式或實質之審查，亦不擔保其正確、完整、安全或可靠。消費者對於使用由其他消費者所提供之內容應自行考量其風險。 
                    <br />
                    <br />
                    十八、申訴權利 
                    <br />
                    消費者不滿意本公司提供之連線品質、遊戲管理、費用計費、其他相關之服務品質，或對本公司依遊戲管理規則之處置不服時，得於收到通知之翌日起七日內至本公司之服務中心或以電子郵件或書面提出申訴，本公司應於接獲申訴後，於十五日內回覆處理之結果。 
                    <br />
                    本公司應於官網或遊戲管理規則中明定服務專線、電子郵件等相關聯絡資訊與二十四小時申訴管道。 
                    <br />
                    消費者反映第三人利用外掛程式或其他影響遊戲公平性之申訴，依第一項規定辦理。 
                    <br />
                    <br />
                    十九、智慧財產權 
                    <br />
                    本公司依本同意書提供之本服務上之所有著作及資料，其著作權、專利權、商標等智慧財產權、所有權或其他權利、利益，均為本公司或原權利人所有，除事先經本公司或原權利人之合法授權外，消費者不得擅自重製、傳輸、改作、編輯或以其他任何形式、或基於任何目的使用，違反者應自負相關之法律責任。 
                    <br />
                    <br />
                    二十、本同意書之終止與退費 
                    <br />
                    消費者得隨時以書面方式通知本公司終止本同意書。 
                    <br />
                    若消費者超過365天未登入使用本服務，本公司將於停止本服務之15日前通知消費者登入，如消費者屆期仍未登入使用，則本同意書自動終止。 
                    <br />
                    消費者有下列重大情事之一者，本公司得依消費者登錄之通訊資料通知消費者後，立即終止本同意書： 
                    <br />
                    (一)	利用任何系統或工具對本公司電腦系統之惡意攻擊或破壞。 
                    <br />
                    (二)	以利用外掛程式、病毒程式、遊戲程式漏洞或其他違反遊戲常態設定或公平合理之方式進行遊戲。 
                    <br />
                    (三)	以冒名、詐騙或其他虛偽不正等方式付費購買點數或遊戲內商品。 
                    <br />
                    (四)	因同一事由違反遊戲管理規則達三次以上，經依本條款第十條第五項通知改善而未改善者。 
                    <br />
                    (五)	經司法機關查獲利用遊戲帳號從事任何不法之行為。 
                    <br />
                    消費者有本條第三項之重大情事或第四項之違約行為，若本公司因此受有損害者，消費者應賠償本公司因此所受之損害。 
                    <br />
                    本公司對本條第三項各款重大情事或第四項違約行為之認定發生錯誤或無法舉證，致消費者受有損害時，本公司應對消費者所受之損害負賠償責任。 
                    <br />
                    本同意書終止時，本公司於扣除必要成本後，應於三十日內以現金、信用卡、匯票或掛號寄發支票方式退還消費者未使用之付費購買之點數(惟不包含消費者免費獲得之儲值點數)或遊戲費用，或依雙方同意之方式處理前述點數或費用。 
                    <br />
                    前項必要成本之項目包含： 
                    <br />
                    (一)	手續費：計算方式為 （會員剩餘未使用的儲值點數 – 免費贈送點數）之儲值對價 X 40%。 
                    <br />
                    (二)	依會員選擇之退費方式，由會員承擔因郵寄/匯票產生之費用。 
                    <br />
                    (三)	其他因會員辦理退費手續所延伸之個人費用。 
                    <br />
                    <br />
                    二十一、停止營運 
                    <br />
                    本公司因停止本服務之營運而終止本同意書者，應於停止終止前三十日公告於官網首頁、遊戲登錄頁面或購買頁面，並依消費者登錄之通訊資料通知消費者。 
                    <br />
                    本公司若未依前項期間公告並通知，除應退還消費者未使用之付費購買點數或遊戲費用且不得扣除必要成本外，並應提供其他合理之補償。 
                    <br />
                    <br />
                    二十二、送達 
                    <br />
                    有關本同意書所有事項之通知，消費者同意本公司依消費者登錄之通訊資料為送達。 
                    <br />
                    前項登錄通訊資料若有變更，消費者應即通知本公司。本公司應依變更後之通訊資料為送達。 
                    <br />
                    本公司依消費者登錄之通訊資料所為之通知發出後，以書面通知到達消費者，或電子郵件進入消費者之電子郵件伺服器中，推定為已送達。 
                    <br />
                    因消費者之故意或過失致本公司無法為送達者，本公司對消費者因無法送達所致之損害不負賠償責任。 
                    <br />
                    <br />
                    二十三、本同意書之內容 
                    <br />
                    除本同意書之條款外，以下視為本同意書之一部分，與本同意書條款具有相同效力：
                    <br />
                    (一)	本公司有關本遊戲服務之廣告或宣傳內容。
                    <br />
                    (二)	計費制遊戲之費率表及遊戲管理規則。
                    <br />
                    本同意書條款如有疑義時，應為消費者有利之解釋。
                    <br />
                    <br />
                    二十四、準據法及管轄法院 
                    <br />
                    本同意書之解釋及適用，以及消費者因使用本服務而與本公司間之權利義務關係，悉依本公司所在地區法律及相關法令解釋適用之（不含涉外民事法律適用法或其他類似法規）。 
                    <br />
                    當事人因本同意書此所衍生之爭議，雙方同意以臺灣臺北地方法院為第一審管轄法院。 
                    <br />
                    前項約定不得排除消費者保護法第四十七條及民事訴訟法第二十八條第二項、第四百三十六條之九規定之適用。 
                    <br />
                    <br />
                  </p>
                  <hr />
                  <h2 id='privacy'>
                    <u>隱私權政策</u>
                  </h2>
                  <br />
                  <p>
                    當您加入本公司即龍邑股份有限公司(下稱「本公司」或「龍邑」)之會員或瀏覽本網站時，您應先詳細閱讀、瞭解本公司之隱私權政策。本公司遵守所有台灣有關隱私資料保護及個人資料安全的相關法令，並希望透過下列的說明回答您對個人隱私權或是個人資料的相關疑慮。 
                    <br />
                    <br />
                    個人資料之蒐集、處理及利用 
                    <br />
                    一、當您在瀏覽或是使用本網站所提供的相關服務時，您可以自行決定是否要註冊本公司會員、請求產品或技術支援、登錄購買產品等，然而部分服務可能會要求您提供相關的個人資料，如您的姓名、地址、電話、電子郵件等資訊(C001)、如您的銀行帳號之號碼與姓名等資訊(C002)、您的性別、出生年月日(C011)及您使用本公司服務之細節、消費模式(C036)或其他與本公司服務而未分類(C132)之個人資料，以利相關人員在最短的時間內提供您最佳的服務或是解決方案。除此之外，本公司也會在不定期舉辦的活動中，像是抽獎活動、競賽、促銷活動等，蒐集由您自願提供的個人資料。 
                    <br />
                    二、當您註冊本公司會員並使用本公司之遊戲服務時，本公司所提供之移動應用程式(下稱「龍邑APP」）可能會需要您所使用之設備的某些許可權(下稱「設備許可權」，包括但不限於：位置許可權、通訊錄許可權、照片許可權、相機許可權、儲存許可權、通知許可權、麥克風許可權、無線資料/WLAN/網路許可權、移動支付許可權、運動/健康許可權等)。本公司透過設備許可權，將會獲取對應的設備資訊或者您的個人資料(下稱「設備資料」，例如：使用如TrueDepth API等面部識別功能，龍邑APP得通過相機許可權獲取使用者的面部特徵資料)。 
                    <br />
                    三、當您使用本公司之遊戲或其他服務，或參加本公司活動而提供上述之個人資料後，非經您本人同意、授權或因其他法律上的規定，本公司不會擅自將個人資料提供予第三人。 
                    <br />
                    四、您因使用本公司之服務或參加本公司活動所提供的個人資料，將主要用於行銷、契約、類似契約或其他法律關係事務、消費者、客戶管理與服務、消費者保護、廣告或商業行為管理、網路購物及其他電子商務服務及調查、統計與研究分析(臺灣個人資料保護法之特定目的項目編號為Ｏ四Ｏ、O六九、Ｏ九Ｏ、O九一、一五二、一四八、一五七)，例如提醒您新產品或服務訊息、功能，或加強產品或服務；或寄送 ecards 或「邀請好友」電子郵件；或寄送實體發票；及/或通知您有關抽獎活動、競賽、促銷活動其他特別活動及優惠。 
                    <br />
                    五、有關您使用本公司遊戲服務而同意本公司蒐集之設備資料，其利用對象及方式： 
                    <br />
                    (一)	設備資料僅用於本公司向您提供龍邑APP中對應的功能。 
                    <br />
                    (二)	本公司僅在提供龍邑APP對應功能之必要範圍內，得對外披露無法識別您個人身份的設備資料。 
                    <br />
                    (三)	本公司僅在提供龍邑APP對應功能之必要範圍內，得與協力廠商共用無法識別您個人身份的設備資料。 
                    <br />
                    (四)	本公司僅在提供龍邑APP對應功能之必要時限及法律規定之保留時限內，保留您的設備資料。 
                    <br />
                    六、本公司於部分服務之網站內，將提供您關於會員個人資料發布之互動設定選項，您可以在選項設定之頁面，依您的需求自行選擇並設定是否公開您的姓名、電子郵件地址、性別、生日、居住地址等資料 
                    <br />
                    七、您就本公司所蒐集之個人資料，得依個人資料保護法得對本公司行使以下權利，惟請求停止蒐集、處理、利用或刪除部分個人資訊，將有導致本公司無法提供您部分遊戲服務或其他服務： 
                    <br />
                    (一)	查詢或請求閱覽。 
                    <br />
                    (二)	請求製給複製本。 
                    <br />
                    (三)	請求補充或更正。 
                    <br />
                    (四)	請求停止蒐集、處理或利用。 
                    <br />
                    (五)	請求刪除。 
                    <br />
                    您如欲行使前項之權利，可透過網站內「聯絡我們」(如客服信箱、客服電話、親自到訪等方式)，並經身分驗證後行使上述權利。 
                    <br />
                    <br />
                    Cookies使用 
                    <br />
                    「Cookies」是指儲存於您電腦、手機中，蒐集您如何使用網頁，並在您下一次登錄該網頁時，提供您更加個人化、流暢瀏覽體驗的技術。目前大多數的網站，都將Cookies視為標準的技術。本公司使用Cookies儲存您使用過本網站的資訊，讓我們能夠持續優化本網站，提供您一個更加舒適良好的上網環境。如果您擔心Cookies的使用會造成您的負擔或是疑慮，目前大多數的瀏覽器都能幫助您清除電腦中的Cookies資料、拒絕接收Cookies或是在發現Cookies時發出提醒告知您該網頁有使用Cookies。 
                    <br />
                    您可以將您的瀏覽器設定為拒絕Cookies，不過請注意，如此一來，部份網頁的功能無法使用。 
                    <br />
                    <br />
                    隱私安全 
                    <br />
                    本公司採用嚴格的隱私安全措施，以避免您的個人資料遭到有心人士的偷取、洩漏、毀損或是竄改。在蒐集、儲存、傳遞、使用您的個人資料時，本公司都實施嚴格的審查措施，只有相關的工作人員擁有觀看、查詢您個人資料的權限，除此之外本公司也定期維護我們的系統，杜絕外來駭客或是惡意軟體的入侵，讓您的個人資料不論是在網路上或是實體都受到完整的保護。然而，本公司無法保證所有儲存的網路資料都安全無虞，因此也建議您定期更換您的密碼，並避免過於簡單的密碼設定，同時採用英文字母大小寫及數字的混合密碼。 
                    <br />
                    <br />
                    聯絡我們 
                    <br />
                    如果您還是對我們隱私權規範有任何問題，我們也相當歡迎您透過網站內的「聯絡我們」與我們聯繫。 
                    <br />
                    <br />
                  </p>
                  <hr />
                  <h2 id='data_use'>
                    <u>個人資料提供同意書</u>
                  </h2>
                  <br />
                  <p>
                    當您完成本公司即龍邑股份有限公司(下稱「龍邑」或「本公司」)會員註冊後，在您第一次登入龍邑網站(下稱「本網站」)或移動應用程式(下稱「App」)購買商品或第一次使用龍邑之服務時，您在線上點選「同意」鍵時，即視為您已經詳細閱讀、了解並願意遵守本件「個人資料同意書」之如後約定內容： 
                    <br />
                    一、本公司蒐集您的個人資料在個人資料保護法及相關法令之規範下，依據本公司隱私權政策，蒐集、處理及利用您的個人資料。 
                    <br />
                    二、您可依您實際之需要，提供本公司以下得以直接或間接識別您的個人資料。 
                    <br />
                    <table className="table table-bordered table-sm">
                      <tbody>
                        <tr>
                          <th>識別類代號</th>
                          <th>項目</th>
                        </tr>
                        <tr>
                          <td>C001</td>
                          <td>姓名、手機號碼及電話號碼、居住地址、電子郵件地址、相片、電子簽章</td>
                        </tr>
                        <tr>
                          <td>C002</td>
                          <td>銀行帳戶之號碼與戶名</td>
                        </tr>
                        <tr>
                          <td>C003</td>
                          <td>身分證字號、健保卡號碼、台胞證號碼、港澳居民來往內地通行證號碼</td>
                        </tr>
                        <tr>
                          <td>C011</td>
                          <td>出生年月日、年齡、出生地、國籍、聲音</td>
                        </tr>
                        <tr>
                          <td>C023</td>
                          <td>父母或監護人</td>
                        </tr>
                        <tr>
                          <td>C036</td>
                          <td>使用本公司服務之細節及消費模式</td>
                        </tr>
                        <tr>
                          <td>C039</td>
                          <td>駕駛執照</td>
                        </tr>
                        <tr>
                          <td>C132</td>
                          <td>透過本網站或App獲取對應的設備資訊或者您的個人資料</td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    三、若您的個人資料有任何異動，請主動向本公司更正，使其保持正確、最新及完整。若您提供錯誤、不實、過時或不完整或具誤導性的資料，本公司有權對您暫時提供各項服務，且您應自行承擔因此所生之損害或損失。 
                    <br />
                    四、您就本公司所蒐集之個人資料，得依個人資料保護法得對本公司行使以下權利，惟請求停止蒐集、處理、利用或刪除部分個人資訊，將有導致本公司無法提供您部分遊戲服務或其他服務： 
                    <br />
                    (一)	查詢或請求閱覽。 
                    <br />
                    (二)	請求製給複製本。 
                    <br />
                    (三)	請求補充或更正。 
                    <br />
                    (四)	請求停止蒐集、處理或利用。 
                    <br />
                    (五)	請求刪除。但因本公司執行業務所必須者，本公司得拒絕之。 
                    <br />
                    五、您同意本公司蒐集您的個人資料，利用於行銷、契約、類似契約或其他法律關係事務、消費者、客戶管理與服務、消費者保護、廣告或商業行為管理、網路購物及其他電子商務服務及調查、統計與研究分析等事項，及本公司隱私權政策所載明之利用目的。 
                    <br />
                    六、您同意本公司蒐集、處理及利用您的個人資料之期間及地區如後： 
                    <br />
                    (一)	期間：自您線上點選「同意」鍵之日起，至您與本公司間所有法律關係終止日後五年。 
                    <br />
                    (二)	地區：全世界。 
                    <br />
                    七、您可自由選擇是否提供本公司您的個人資料，但若您所提供之個人資料，經檢舉或本公司發現不足以確認您的身分真實性或其有冒用、盜用第三人個人資料或資料不實等情形，本公司有權對您暫時停止提供各項服務，且您應自行承擔因此所生之損害或損失。 
                    <br />
                    八、本公司有權隨時修改或增訂本件「個人資料提供同意書」之內容，並應依照「龍邑會員服務條款」第六條規定辦理。 
                    <br />
                    九、本件「個人資料提供同意書」之解釋與適用，依本公司所在地區法律及相關法令解釋適用之（不含涉外民事法律適用法或其他類似法規）；若您與本公司因本件「個人資料提供同意書」衍生訴訟者，並同意以臺灣臺北地方法院為第一審管轄法院。 
                    <br />
                    <br />
                  </p>
                  <hr />
                  <h2 id='rules'>
                    <u>遊戲管理規則</u>
                  </h2>
                  <br />
                  <p>
                    一、遊戲玩家應遵守下列各項之規定： 
                    <br />
                    1.於遊戲內之公開頻道以洗頻或使用不雅、侮辱、毀謗他人或違反公序良俗之具攻擊性言詞，有致使其他玩家不悅或發生爭議可能之行為。 
                    <br />
                    2.發表具毀謗內容或散播不實謠言、侵權、違反公序良俗之具攻擊性言詞，致有嚴重侵害本公司權益或可能之行為。 
                    <br />
                    3.於遊戲內從事非法之行為，包含但不限於散佈色情影片、外掛、假網站、援交訊息、藥品買賣、槍械武器及其他現行法令所禁止之行為。 
                    <br />
                    4.惡意妨礙或以任何方式，包含但不限於洗頻、密語等而造成本公司人員無法有效提供服務予其他玩家之行為。 
                    <br />
                    5.企圖或偽冒本公司人員或遊戲開發商，或以類似字元，有致使他人模糊、無法辨識或誤認之行為。 
                    <br />
                    6.宗教或公眾人物之負面言論或名稱，包含但不限散播、宣傳、影射等之行為。 
                    <br />
                    7.遊戲帳號應妥善保管於個人使用，不可共用帳號、將其帳號及密碼出售、轉讓或出借予第三人使用或委託他人付費購買點數。 
                    <br />
                    8.於遊戲內使用外掛程式，包含但不限於自動腳本、加速器、按鍵精靈、連點程式，泛指外掛或非本公司提供之輔助工具或有外掛程式之散播、宣傳、影射等之行為。 
                    <br />
                    9.不法擅自修改遊戲資料、破解封包及任何駭客行為或相關之行為，包含但不限散播、宣傳、影射等之行為。 
                    <br />
                    10.於遊戲內利用 BUG 進行遊戲或其他相關行為，包含但不限於散播、宣傳、影射等之行為。 
                    <br />
                    11.不法擅自複製道具、虛擬貨幣、寶物或為收取相關異常、虛擬貨幣、寶物或其他相關行，包含但不限於散播、宣傳、影射之行為。 
                    <br />
                    12.利用本遊戲或於遊戲內從事任何形式或類似之商業行為，包含但不限於以會員帳號、遊戲內物品或金錢換取金錢（新台幣）或有價物品及與任何會員從事與金錢（新台幣）相關聯之交易活動。 
                    <br />
                    13.消費記錄異常或債信不良，包含但不限於異常大量儲值、帳單異常、電信業者來函等之行為。 
                    <br />
                    14.涉嫌以詐欺、盜用等不法手段而取得其他會員帳號內之金錢、道具等或其他造成會員權益受損之行為。 
                    <br />
                    15.以虛偽不實之內容欺騙本公司人員 ，企圖得到不當利益或影響其他會員權益之行為。 
                    <br />
                    16.若於遊戲內相關塗裝工坊，自行投稿設計，參照UGC(User Generated Content 使用者原創供應內容)，應遵守本公司所在地之著作權法律規定。 
                    <br />
                    <br />
                    二、其他約定事項 
                    <br />
                    1.遊戲玩家應遵守本遊戲管理規則之規定，若有違反上述規定，本公司得視情節輕重執行以下懲處： 
                    <br />
                    （1）禁言1~7天。 
                    <br />
                    （2）限制部分服務使用權利1~7天。 
                    <br />
                    （3）帳號停權1~7天。 
                    <br />
                    但凡情節嚴重，本公司得加重處罰或永久終止會員之全部或部份網路服務使用權利等，玩家並應自行承擔因此所受之相關損失。 
                    <br />
                    2.若發生以上遊戲管理規則所未規範或未涵蓋之侵害遊戲平衡或其他會員權益之行為，將依本公司客服人員視情節輕重，依據本遊戲管理規則及龍邑會員服務條款判斷處理。 
                    <br />
                    3.若遊戲玩家有違反著作權等相關法律，本公司除依據違規情況對違規玩家的作品進行下架或進一步限制相關功能，亦將依法追究衍生之法律責任。 
                    <br />
                    4.本公司有隨時更新與修改本遊戲管理規則之權利，並將依據龍邑會員服務條款規定之方式變更之。 
                    <br />
                    <br />
                  </p>
                  <hr />
                  <h2 id='refund'>
                    <u>退費流程</u>
                  </h2>
                  <br />
                  <p>
                    1.會員至該遊戲客服中心填寫提問單，申請契約終止退費。 
                    <br />
                    2.由客服人員計算帳號可退費金額，並再次確認契約終止意願。 
                    <br />
                    3.若同意契約終止，客服人員提供帳號契約終止暨退費申請同意書。 
                    <br />
                    4.帳號契約終止暨退費申請同意書填寫完畢，將文件寄送至本公司。 
                    <br />
                    5.本公司核對資料無誤後，於30個工作天內退費。 
                    <br />
                    <br />
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className='button'>
            <button onClick={this.props.history.goBack}>返回</button>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Complete_agreement);
